import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { post } from '../lib/api';
import { useAuth } from '../lib/auth';
import { time } from '../lib/format';
import { isNativeApp } from '../lib/app';
import { toast } from './ui';

const ROLES = ['guardian', 'staff', 'admin'] as const;

/** Shown only inside a live-demo sandbox: switch role, see when the sandbox ends */
export function DemoBar() {
  const { t } = useTranslation();
  const { user, school, refresh } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  if (!school?.isDemo || !user) return null;

  const switchTo = async (role: (typeof ROLES)[number]) => {
    if (role === user.role || busy) return;
    setBusy(true);
    try {
      await post('/api/demo/switch', { role });
      await refresh();
      navigate('/', { replace: true });
    } catch {
      toast(t('errors.generic'), 'err');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="demobar" role="region" aria-label={t('demo.bar')}>
      <strong className="demobar-label">{t('demo.bar')}</strong>
      <div className="demobar-roles" role="group" aria-label={t('demo.viewAs')}>
        <span className="demobar-viewas">{t('demo.viewAs')}</span>
        {ROLES.map((r) => (
          <button key={r} type="button" aria-pressed={user.role === r} disabled={busy} onClick={() => void switchTo(r)}>
            {t(`role.${r}`)}
          </button>
        ))}
      </div>
      {school.demoExpiresAt && <span className="demobar-ends">{t('demo.endsAt', { time: time(school.demoExpiresAt) })}</span>}
      {!isNativeApp() && (
        <a className="demobar-cta" href="/welcome#contact">
          {t('demo.getIt')}
        </a>
      )}
    </div>
  );
}
